import React from 'react'

import { Grid, Container, Segment, Popup, Image, Card } from 'semantic-ui-react'
import { CustomCardGroup, FlexBlock, Link } from '@/components/OtherCustomComponents/style'
import { themes } from '@/theme/context'

import { FullWidthBackgroundContainer, ThemedText, IconsWrapper, BodyContainer, CenterText, StyledSegment, LeftBorderedSegment, LeftBorderedSegmentList, CustomGrid, ImageContainer } from './style'

export const BodyComponent = ({ drupalHost, currentAct }) => {
    return (<BodyContainer>
        <FullWidthBackgroundContainer>
            <Container>
                <CustomCardGroup itemsPerRow={2} stackable>
                    <Card>
                        <Card.Content>
                            <FlexBlock>
                                <Image spaced="right" src="/themes/diag/images/diag1.svg" />
                                <b>Диагностика знаний</b>
                            </FlexBlock>
                            <p>Позволяет определить реальный уровень обязательной подготовки студентов-первокурсников по&nbsp;предметам школьного курса как на&nbsp;базе 9, так и 11 классов</p>
                        </Card.Content>
                    </Card>
                    <Card>
                        <Card.Content>
                            <FlexBlock>
                                <Image spaced="right" src="/themes/diag/images/diag2.svg" />
                                <b>Диагностика готовности</b>
                            </FlexBlock>
                            <p>Выявляет особенности мотивации к&nbsp;учению, интеллектуальных способностей и качеств личности как факторов дальнейшего успешного обучения</p>
                        </Card.Content>
                    </Card>
                </CustomCardGroup>
            </Container>
        </FullWidthBackgroundContainer>
        <Container>
            <p>Оценка качества подготовки обучающихся, проведенная с&nbsp;помощью сервиса «{themes[currentAct].title}», может быть определена как вид внутренней системы оценки качества образования (<Link href="/node/1668">ВСОКО</Link>) и зачтена при&nbsp;прохождении государственных аккредитационных процедур контроля.</p>
            <p>Система тестирования отличается широким разнообразием представленных в&nbsp;сервисах портала <Link href={`//test.${drupalHost}/demo/training/student/index.html?alltypes`}>типов заданий</Link>, позволяющих эффективно оценивать образовательные достижения студентов.</p>
            <CustomGrid stackable>
                <Grid.Row>
                    <Grid.Column>
                        <StyledSegment inverted compact>
                            <b>Дисциплины среднего общего образования / 11 класс</b>
                        </StyledSegment>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={4}>
                    <Grid.Column>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%9C%D0%B0%D1%82%D0%B5%D0%BC%D0%B0%D1%82%D0%B8%D0%BA%D0%B0%2011%20%D0%BA%D0%BB.doc">Математика</Link></p>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%A0%D1%83%D1%81%D1%81%D0%BA%D0%B8%D0%B9%20%D1%8F%D0%B7%D1%8B%D0%BA%2011%20%D0%BA%D0%BB.doc">Русский язык</Link></p>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%A5%D0%B8%D0%BC%D0%B8%D1%8F%2011%20%D0%BA%D0%BB.doc">Химия</Link></p>
                    </Grid.Column>
                    <Grid.Column>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%A4%D0%B8%D0%B7%D0%B8%D0%BA%D0%B0%2011%20%D0%BA%D0%BB.doc">Физика</Link></p>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%98%D0%BD%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%82%D0%B8%D0%BA%D0%B0%2011%20%D0%BA%D0%BB.doc">Информатика</Link></p>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%91%D0%B8%D0%BE%D0%BB%D0%BE%D0%B3%D0%B8%D1%8F%2011%20%D0%BA%D0%BB.doc">Биология</Link></p>
                    </Grid.Column>
                    <Grid.Column>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%98%D1%81%D1%82%D0%BE%D1%80%D0%B8%D1%8F%2011%20%D0%BA%D0%BB.doc">История</Link></p>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%90%D0%BD%D0%B3%D0%BB%D0%B8%D0%B9%D1%81%D0%BA%D0%B8%D0%B9%20%D1%8F%D0%B7%D1%8B%D0%BA%2011%20%D0%BA%D0%BB.doc">Английский язык</Link></p>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%93%D0%B5%D0%BE%D0%B3%D1%80%D0%B0%D1%84%D0%B8%D1%8F%2011%20%D0%BA%D0%BB.doc">География</Link></p>
                    </Grid.Column>
                    <Grid.Column>
                        <p>
                            <Link href="/sites/default/files/diag/vpr/%D0%9E%D1%81%D0%BD%D0%BE%D0%B2%D1%8B%20%D0%B1%D0%B5%D0%B7%D0%BE%D0%BF%D0%B0%D1%81%D0%BD%D0%BE%D1%81%D1%82%D0%B8%20%D0%B8%20%D0%B7%D0%B0%D1%89%D0%B8%D1%82%D1%8B%20%D0%A0%D0%BE%D0%B4%D0%B8%D0%BD%D1%8B%2011%20%D0%BA%D0%BB.doc">
                            Основы безопасности и защиты Родины
                            </Link>
                        </p>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%9E%D0%B1%D1%89%D0%B5%D1%81%D1%82%D0%B2%D0%BE%D0%B7%D0%BD%D0%B0%D0%BD%D0%B8%D0%B5%2011%20%D0%BA%D0%BB.doc">Обществознание</Link></p>
                    </Grid.Column>
                </Grid.Row>
            </CustomGrid>
            <br/>
            <CustomGrid stackable>
                <Grid.Row>
                    <Grid.Column verticalAlign='middle'>
                        <div className="flexable">
                            <StyledSegment inverted compact>
                                <b>Дисциплины основного общего образования / 9 класс</b>
                            </StyledSegment>
                            <ImageContainer>
                                <Image size="tiny" centered spaced src="/themes/diag/images/diag16.svg" />
                            </ImageContainer>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={4}>
                    <Grid.Column>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%9C%D0%B0%D1%82%D0%B5%D0%BC%D0%B0%D1%82%D0%B8%D0%BA%D0%B0%209%20%D0%BA%D0%BB.doc">Математика</Link></p>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%A0%D1%83%D1%81%D1%81%D0%BA%D0%B8%D0%B9%20%D1%8F%D0%B7%D1%8B%D0%BA%209%20%D0%BA%D0%BB.doc">Русский язык</Link></p>
                        <p><Link href="/sites/default/files/diag/vpr/%D0%98%D0%BD%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%82%D0%B8%D0%BA%D0%B0%209%20%D0%BA%D0%BB.doc">Информатика</Link></p>
                    </Grid.Column>
                    <Grid.Column>
                        <p><ThemedText><b><Link href="/sites/default/files/diag/vpr/%D0%A5%D0%B8%D0%BC%D0%B8%D1%8F%209%20%D0%BA%D0%BB.doc">+Химия</Link></b></ThemedText></p>
                        <p><ThemedText><b><Link href="/sites/default/files/diag/vpr/%D0%A4%D0%B8%D0%B7%D0%B8%D0%BA%D0%B0%209%20%D0%BA%D0%BB.doc">+Физика</Link></b></ThemedText></p>
                        <p><ThemedText><b><Link href="/sites/default/files/diag/vpr/%D0%91%D0%B8%D0%BE%D0%BB%D0%BE%D0%B3%D0%B8%D1%8F%209%20%D0%BA%D0%BB.doc">+Биология</Link></b></ThemedText></p>
                    </Grid.Column>
                    <Grid.Column>
                        <p><ThemedText><b><Link href="/sites/default/files/diag/vpr/%D0%98%D1%81%D1%82%D0%BE%D1%80%D0%B8%D1%8F%209%20%D0%BA%D0%BB.doc">+История</Link></b></ThemedText></p>
                        <p><ThemedText><b><Link href="/sites/default/files/diag/vpr/%D0%90%D0%BD%D0%B3%D0%BB%D0%B8%D0%B9%D1%81%D0%BA%D0%B8%D0%B9%20%D1%8F%D0%B7%D1%8B%D0%BA%209%20%D0%BA%D0%BB.doc">+Английский язык</Link></b></ThemedText></p>
                        <p><ThemedText><b><Link href="/sites/default/files/diag/vpr/%D0%93%D0%B5%D0%BE%D0%B3%D1%80%D0%B0%D1%84%D0%B8%D0%B8%209%20%D0%BA%D0%BB.doc">+География</Link></b></ThemedText></p>
                    </Grid.Column>
                    <Grid.Column>
                        <p>
                            <ThemedText>
                                <b><Link href="/sites/default/files/diag/vpr/%D0%9E%D1%81%D0%BD%D0%BE%D0%B2%D1%8B%20%D0%B1%D0%B5%D0%B7%D0%BE%D0%BF%D0%B0%D1%81%D0%BD%D0%BE%D1%81%D1%82%D0%B8%20%D0%B8%20%D0%B7%D0%B0%D1%89%D0%B8%D1%82%D1%8B%20%D0%A0%D0%BE%D0%B4%D0%B8%D0%BD%D1%8B%209%20%D0%BA%D0%BB.doc">+Основы безопасности и защиты Родины</Link></b>
                            </ThemedText>
                        </p>
                        <p><ThemedText><b><Link href="/sites/default/files/diag/vpr/%D0%9E%D0%B1%D1%89%D0%B5%D1%81%D1%82%D0%B2%D0%BE%D0%B7%D0%BD%D0%B0%D0%BD%D0%B8%D0%B5%209%20%D0%BA%D0%BB.doc">+Обществознание</Link></b></ThemedText></p>
                    </Grid.Column>
                </Grid.Row>
            </CustomGrid>
            <br/>
            <Grid stackable>
                <Grid.Row>
                    <Grid.Column width={11}>
                        <p>Структуры содержания и педагогические измерительные материалы по дисциплинам соотносятся с содержанием КИМ <b>Всероссийских проверочных работ СПО</b>.</p>
                        <p>Это позволяет использовать тестирование в обновленном сервисе с целью подготовки обучающихся образовательных организаций СПО к процедурам ВПР для оценки результатов обучения по общеобразовательным предметам, освоенным по программам СПО на базе основного общего образования и среднего общего образования.</p>
                    </Grid.Column>
                    <Grid.Column width={5} verticalAlign='middle'>
                        <Image centered src="/themes/diag/images/diag15.svg" />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
        <FullWidthBackgroundContainer>
            <Container>
                <p><b><ThemedText>Диагностика готовности</ThemedText></b> первокурсников к&nbsp;продолжению обучения в&nbsp;вузе/ссузе выявляет психологические особенности студента для&nbsp;дальнейшего проведения дополнительных учебных занятий, индивидуальных консультаций, социально-психологических тренингов.</p>
                <p>Организаторы тестирования могут самостоятельно выбрать методики диагностики:</p>
                <Grid stackable>
                    <Grid.Row columns={3}>
                        <Grid.Column>
                            <LeftBorderedSegment>
                                диагностика мотивационного компонента по&nbsp;методике С.А. Пакулиной, С.М. Кетько
                            </LeftBorderedSegment>
                        </Grid.Column>
                        <Grid.Column>
                            <LeftBorderedSegment>
                                диагностика когнитивного компонента с&nbsp;помощью теста интеллекта Р. Амтхауэра 
                            </LeftBorderedSegment>
                        </Grid.Column>
                        <Grid.Column>
                            <LeftBorderedSegment>
                                диагностика личностного компонента с&nbsp;использованием пятифакторного опросника
                            </LeftBorderedSegment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </FullWidthBackgroundContainer>
        <Container>
            <Segment>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <p><ThemedText><b><Link href="/sites/default/files/diab/otchet_dt.pdf">Отчет «Диагностика знаний студентов первого курса»</Link></b></ThemedText></p>
                            <p>содержит информационно-аналитические материалы и результаты тестирования по&nbsp;каждой дисциплине для&nbsp;представителей ректората, деканов, заведующих кафедрами, профессорско-преподавательского состава.</p>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <IconsWrapper>
                                <Popup
                                    content='гистограммы плотности распределения результатов'
                                    trigger={<Image src="/themes/diag/images/diag3.svg" floated="left" />}
                                    hideOnScroll={true}
                                    style={{ fontSize: '18px' }}
                                    hoverable={true}

                                />
                                <Popup
                                    content='диаграммы ранжирования факультетов (направлений подготовки факультетов) по&nbsp;проценту студентов, преодолевших пороговые значения при&nbsp;выполнении заданий карты коэффициентов решаемости по&nbsp;темам'
                                    trigger={<Image src="/themes/diag/images/diag4.svg" floated="right" />}
                                    hideOnScroll={true}
                                    style={{ fontSize: '18px' }}
                                    size="huge"
                                    wide={true}
                                    hoverable={true}
                                />
                                <Popup
                                    content='рейтинг-листы студентов'
                                    trigger={<Image src="/themes/diag/images/diag5.svg" centered />}
                                    hideOnScroll={true}
                                    style={{ fontSize: '18px' }}
                                    hoverable={true}
                                />
                            </IconsWrapper>
                        </Grid.Column>
                        <Grid.Column width={4} verticalAlign='middle'>
                            <Image fluid src="/themes/diag/images/diag6.png" />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
            <Segment>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <p><ThemedText><b>Статистика по&nbsp;итогам диагностики готовности первокурсников</b></ThemedText></p>
                                <p>отражает сведения о&nbsp;группах студентов по&nbsp;факультетам. Данные предназначены для&nbsp;дальнейшей работы психологов образовательных организаций, кураторов, специалистов отделов по&nbsp;воспитательной работе, заведующих кафедрами и деканов.</p>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <IconsWrapper>
                                <Popup 
                                    content='диаграмма уровня развития мотивов поступления в&nbsp;вуз'
                                    trigger={<Image src="/themes/diag/images/diag7.svg" floated="left"/>}
                                    hideOnScroll={true}
                                    style={{fontSize: '18px'}}
                                    hoverable={true}
                                />
                                <Popup 
                                    content='диаграмма уровня развития профессиональных мотивов'
                                    trigger={<Image src="/themes/diag/images/diag8.svg" floated="right"/>}
                                    hideOnScroll={true}
                                    style={{fontSize: '18px'}}
                                    hoverable={true}
                                />
                                <Popup 
                                    content='диаграмма уровня развития мотивации к&nbsp;обучению'
                                    trigger={<Image src="/themes/diag/images/diag9.svg" centered/>}
                                    hideOnScroll={true}
                                    style={{fontSize: '18px'}}
                                    hoverable={true}
                                />
                                <Popup 
                                    content='индивидуальный профиль интеллекта первокурсника'
                                    trigger={<Image src="/themes/diag/images/diag10.svg" floated="left"/>}
                                    hideOnScroll={true}
                                    style={{fontSize: '18px'}}
                                    hoverable={true}

                                />
                                <Popup 
                                    content='диаграмма выраженности свойств личности и черт характера'
                                    trigger={<Image src="/themes/diag/images/diag11.svg" floated="right"/>}
                                    hideOnScroll={true}
                                    style={{fontSize: '18px'}}
                                    hoverable={true}
                                />
                            </IconsWrapper>
                        </Grid.Column>
                        <Grid.Column width={4} verticalAlign='middle'>
                            <Image fluid src="/themes/diag/images/diag12.png"/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
        </Container>
        <FullWidthBackgroundContainer>
            <Container>
                <CenterText>
                    <ThemedText><Link href="//diag.i-exam.ru/sites/default/files/diab/monitoring_dt.pdf"><b>Отчет «Мониторинг результатов диагностического тестирования»</b></Link></ThemedText>
                </CenterText>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={10}>
                            <Image size='medium' centered src="/themes/diag/images/diag13.png?new"/>
                            <br/>
                            формируется по&nbsp;каждой дисциплине для&nbsp;образовательных организаций, неоднократно принимавших участие в&nbsp;диагностическом тестировании.
                        </Grid.Column>
                        <Grid.Column width={6}>
                            <LeftBorderedSegmentList>количественные показатели участия вуза/ссуза в&nbsp;тестировании</LeftBorderedSegmentList>
                            <LeftBorderedSegmentList>гистограммы плотности распределения результатов</LeftBorderedSegmentList>
                            <LeftBorderedSegmentList>карты и таблицы коэффициентов решаемости заданий по&nbsp;темам</LeftBorderedSegmentList>
                            <LeftBorderedSegmentList>обобщенные структуры измерительных материалов по&nbsp;дисциплинам</LeftBorderedSegmentList>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </FullWidthBackgroundContainer>
    </BodyContainer>)
}